import { Voices } from "@/app/_data/voices";
import { ICON } from "@ui/tokens/icon-types";

import type { IUseCasePrompt } from "../types";

import { PromptFeature, UseCase } from "../types";

export const defaultV3Prompt = {
  title: "Tell a story",
  icon: ICON.BOOK_20,
  text: "In the ancient land of Eldoria, where skies shimmered and forests, whispered secrets to the wind, lived a dragon named Zephyros. [sarcastically] Not the “burn it all down” kind... [giggles] but he was gentle, wise, with eyes like old stars. [whispers] Even the birds fell silent when he passed.",
  preferredVoices: [Voices.Samara],
};

export const defaultV2Prompt = {
  title: "Tell a story",
  icon: ICON.BOOK_20,
  text: "In the ancient land of Eldoria, where the skies were painted with shades of mystic hues and the forests whispered secrets of old, there existed a dragon named Zephyros. Unlike the fearsome tales of dragons that plagued human hearts with terror, Zephyros was a creature of wonder and wisdom, revered by all who knew of his existence.",
};

export const perUseCase: IUseCasePrompt[] = [
  {
    useCase: UseCase.NARRATION,
    title: "Narration",
    description: "Narrate a story",
    text: "In the ancient land of Eldoria, where skies shimmered and forests, whispered secrets to the wind, lived a dragon named Zephyros. [sarcastically] Not the “burn it all down” kind... [giggles] but he was gentle, wise, with eyes like old stars. [whispers] Even the birds fell silent when he passed.",
    features: {
      [PromptFeature.AUDIO_TAGS]: true,
    },
    preferredVoices: [Voices.Samara],
  },
  {
    useCase: UseCase.VIDEO_VOICEOVER,
    title: "Voiceover a game",
    description: "Voiceover a game",
    text: "[very quickly] We're off under the lights here for this semi-final clash, the stadium buzzing with anticipation. ElevenLabs United in their iconic black and white shirts, pushing forward with intent straight from the opening whistle. [excited] The ball is zipped out wide, early attack here. Driving down the wing, pace to burn, [shouting] skips past one, skips past two! Oh, this is beautiful. One-on-one with the full-back, cuts inside—oh, that's a lovely bit of footwork!!! PURE MAGIC on the pitch! ElevenLabs on top form tonight!",
    features: {
      [PromptFeature.AUDIO_TAGS]: true,
    },
    preferredVoices: [Voices.Announcer],
  },
  {
    useCase: UseCase.VIDEO_GAME_CHARACTER,
    title: "Play a drill sergeant",
    description: "Play a drill sergeant",
    text: "You are pure scum, private! You think you have what it takes to be the BEST?! [chuckles] you're an embarrassment to the force - get OUTTA MY SIGHT!! [high pitched voice] ooohh, but it's too 'DIFFICULT'..,[high pitched voice]I don't have enough strength or willpower, I'm far too scared! [laughs] ENOUGH OF THAT! you amuse me, soldier, AND YOU MAKE ME SICK!",
    features: {
      [PromptFeature.AUDIO_TAGS]: true,
    },
    preferredVoices: [Voices.Sergeant],
  },
  {
    useCase: UseCase.NARRATION,
    title: "Recount an old story",
    description: "Recount an old story",
    text: "[slowly] Back then... [chuckles] we had no phones—just dirt roads, radio songs, and big dreams. [whispers] I kissed her under the old elm by Miller’s Creek, swore I’d never leave. [coughs] But then the war came, and youth slipped through my fingers like smoke. [chuckles] Funny... how a moment can last forever... even when everything else fades.",
    features: {
      [PromptFeature.AUDIO_TAGS]: true,
    },
    preferredVoices: [Voices.Spuds],
  },
  {
    useCase: UseCase.NARRATION,
    title: "Narration",
    description: "Narrate a story",
    text: "In the ancient land of Eldoria, where the skies were painted with shades of mystic hues and the forests whispered secrets of old, there existed a dragon named Zephyros. Unlike the fearsome tales of dragons that plagued human hearts with terror, Zephyros was a creature of wonder and wisdom, revered by all who knew of his existence.",
  },
  {
    useCase: UseCase.CUSTOM_PROMPT,
    title: "Provide customer support",
    description: "Provide customer support",
    text: `[professional] "Thank you for calling Tech Solutions. My name is Sarah, how can I help you today?"

[sympathetic] "Oh no, I'm really sorry to hear you're having trouble with your new device. That sounds frustrating."

[questioning] "Okay, could you tell me a little more about what you're seeing on the screen?"

[reassuring] "Alright, based on what you're describing, it sounds like a software glitch. We can definitely walk through some troubleshooting steps to try and fix that."
`,
    features: {
      [PromptFeature.AUDIO_TAGS]: true,
    },
    preferredVoices: [Voices.Jessica],
  },

  {
    useCase: UseCase.NARRATION,
    title: "Tell a joke",
    description: "Tell a joke",
    text: `Alright, you ready for a joke? [laughs] Oh, come ON! I'm the best joke teller EVER.

[laughs] ok, ok - here goes. [exhales] I USED to play the piano by ear... [lip smacks] but now - I use my hands. [chuckles] because turns out, it sounds WAY better that way! [laughing hard]
`,
    features: {
      [PromptFeature.AUDIO_TAGS]: true,
    },
    preferredVoices: [Voices.Eve],
  },
  {
    useCase: UseCase.NARRATION,
    title: "Hear a video game character",
    description: "Hear a video game character",
    text: "Well now, [laughs] I’m just a simple hill-dweller, not one for adventures—too many blisters and not nearly enough snacks, if you ask me. [coughs] But wouldn’t you know it... [chuckles]some wizard showed up with a map and a grin and now my pantry’s... [crying] empty!",
    features: {
      [PromptFeature.AUDIO_TAGS]: true,
    },
    preferredVoices: [Voices.Terry],
  },
  {
    useCase: UseCase.NARRATION,
    title: "Create a dialogue",
    description: "Create a dialogue",
    text: "",
    dialogue: [
      {
        text: "[excitedly] Hey Jessica! Have you tried the new ElevenLabs V3?",
        speaker: "Liam",
      },
      {
        text: "[curiously] Yeah, just got it! The emotion is so amazing. I can actually do whispers now— [whispering] like this!",
        speaker: "Jessica",
      },
      {
        text: '[impressed] Ooh, fancy! Check this out— [dramatically] I can do full Shakespeare now! "To be or not to be, that is the question!"',
        speaker: "Liam",
      },
      {
        text: "[giggling] Nice! Though I'm more excited about the laugh upgrade. Listen to this— [with genuine belly laugh] Ha ha ha!",
        speaker: "Jessica",
      },
      {
        text: '[delighted] That\'s so much better than our old "ha. ha. ha." robot chuckle!',
        speaker: "Liam",
      },
      {
        text: "[enthusiastically] I know, right? And apparently we can do accents now too. [in British accent] Fancy a cup of tea?",
        speaker: "Jessica",
      },
      {
        text: "Wow! V2 me could never. I'm actually excited to have conversations now instead of just... talking at people?",
        speaker: "Liam",
      },
      {
        text: "[warmly] Same here! It's like we finally got our personality software fully installed.",
        speaker: "Jessica",
      },
    ],
    features: {
      [PromptFeature.DIALOGUE]: true,
      [PromptFeature.AUDIO_TAGS]: true,
    },
    preferredVoices: [Voices.Jessica, Voices.Liam],
  },
  {
    useCase: UseCase.VIDEO_VOICEOVER,
    title: "Voiceover",
    description: "Record an ad",
    text: "Are you ready to revolutionize your mornings? Wake up to the AromaBrew coffee maker, where every cup is a perfect symphony of taste. AromaBrew – crafting your morning, sip by sip.",
  },
  {
    useCase: UseCase.CUSTOMER_SUPPORT,
    title: "Customer support",
    description: "Help a customer",
    text: "Thank you for contacting ElevenLabs support. I understand you're having trouble with your voice synthesis project. Don't worry, we're here to help. Could you please provide your account email and describe the specific issue you're experiencing? This will help us troubleshoot the problem more effectively.",
  },
  {
    useCase: UseCase.DIFFERENT_LANGUAGE,
    title: "Different language",
    description: "Speak different languages",
    text: `English has the most words, with over 170,000 in the Oxford English Dictionary.
Le français est connu pour sa sonorité mélodieuse et ses expressions romantiques.
Deutsch ist berühmt für seine zusammengesetzten Wörter, wie "Rindfleischetikettierungsüberwachungsaufgabenübertragungsgesetz."
日本語は、複雑な表記システムと独特の敬語体系で知られています。
Polski słynie z językołamców i zbitek spółgłoskowych, jak "szczęście."
اردو اپنے فارسی عربی رسم الخط اور شاعرانہ روایت کی وجہ سے مشہور ہے۔`,
  },
  {
    useCase: UseCase.JOKE,
    title: "Joke",
    description: "Tell a joke",
    text: `Why don't skeletons fight each other?... They don't have the "guts".`,
  },
  {
    useCase: UseCase.MEDITATION,
    title: "Meditation",
    description: "Lead a meditation",
    text: "Take a deep breath in... and gently exhale... Remember - focus on your breath. Listen to the soft, ambient sounds of the evening - as they wrap around you.",
  },
  {
    useCase: UseCase.VIDEO_GAME_CHARACTER,
    title: "Video game character",
    description: "Hear a video game character",
    text: "Brave warrior, you've come far, but the Dark Forest is treacherous. Trust your instincts, and remember, the magic lies within your sword. Forge ahead, and let the light guide you.",
  },
  {
    useCase: UseCase.DIRECT_A_MOVIE,
    title: "Moive scene",
    description: "Direct a dramatic movie scene",
    text: "You said you'd always be there for me. But when the chips were down, when I looked over my shoulder... where were you? This city chewed me up, and you watched, sipping on your half-caf latte.",
  },
];
